import { format } from 'date-fns'

const intervals = [
  { label: 'y', seconds: 31536000 },
  { label: 'mo', seconds: 2592000 },
  { label: 'd', seconds: 86400 },
  { label: 'hr', seconds: 3600 },
  { label: 'm', seconds: 60 },
  { label: 's', seconds: 1 },
]

export const timeSince = (timestamp: number): string => {
  const seconds = Math.floor((Date.now() - timestamp) / 1000)
  if (seconds < 1) {
    return 'Just now'
  }

  const interval = intervals.find((i) => i.seconds <= seconds) || {
    label: '',
    seconds: 1,
  }
  const count = Math.floor(seconds / interval.seconds) || 'Unknown'

  const textDuration = interval.label ? `${interval.label}` : ''

  return `${count}${textDuration}`
}

/**
 * Formats the duration of a video in seconds to the desired format for the UI.
 * @param durationInSeconds -- The total amount of seconds in the video.
 * @returns The video's duration formatted in M:SS
 */
export const formatVideoDuration = (durationInSeconds: number): string => {
  const roundedDuration = Math.floor(durationInSeconds)
  const minutes = Math.floor(roundedDuration / 60)
  const seconds = roundedDuration % 60

  return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`
}

export const formatDateTime = (timestamp: number): string => {
  const date = new Date(timestamp)
  return format(date, 'EEE MMM do YYY - h:mmaaa')
}

export const formatShortDateTime = (timestamp: number): string => {
  const date = new Date(timestamp)
  return format(date, 'EEE h:mmaaa')
}
